import { SET_LOCATION, SET_LOCATION_ERROR } from "../actions/userLocationActions"

export const userLocationReducer = (state, action) => {
    switch(action.type) {
        case SET_LOCATION:
            return {
                ...state,
                addressLine1: action.payload.addressLine1,
                addressLine2: action.payload.addressLine2,
                addressLine3: action.payload.addressLine3,
                addressType: action.payload.addressType,
                latitude: action.payload.latitude,
                longitude: action.payload.longitude,
                recordId: action.payload.recordId,
                consent: action.payload.consent,
                isError: false,
                errorMessage: ''
            }
        case SET_LOCATION_ERROR:
            return {
                ...state,
                isError: action.payload.isError,
                errorMessage: action.payload.errorMessage
            };
        default:
            return state;
    }
}